<template>
  <div class="mypage-contract-details-section">
    <h4 class="mypage-contract-details-section__title">
      {{ $tc('MypagePage.MypageContract.detailsPage.contractDetails') }}
    </h4>
    <fieldset-confirm-parts
      :label="$tc('MypagePage.MypageContract.detailsPage.registrationDate')"
      :value="myContractData.registrationDate"
    />
    <fieldset-confirm-parts
      :label="$tc('MypagePage.MypageContract.detailsPage.nextPayment')"
      :value="nextPaymentText ? nextPaymentText : '---'"
      :attention="
        nextPaymentText ? $tc('MypagePage.MypageContract.detailsPage.nextPaymentAttention') : ''
      "
    />
    <fieldset-confirm-parts
      :label="$tc('MypagePage.MypageContract.detailsPage.paymentMethod')"
      :value="
        myContractData.paymentMethod && myContractData.nextPaymentPrice
          ? `${myContractData.paymentMethod}<br>${myContractData.creditCardData.cardLast4Digits} （${myContractData.creditCardData.cardExpiration}）`
          : '---'
      "
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import FieldsetConfirmParts from '@/components/common/form/FieldsetConfirmParts.vue'
import { MyContractDataType } from '@/components/MypageContractPage/hook/useMypageContract'
import I18n from '@/locales/I18n'

/**
 * マイページ: 契約情報 現在のプラン セクション
 */
export default defineComponent({
  name: 'MypageContractDetailsSection',
  components: {
    FieldsetConfirmParts,
  },
  props: {
    myContractData: {
      type: Object as PropType<MyContractDataType>,
      default: () => ({}),
    },
  },
  setup(props) {
    /* 次の支払い金額の利用期間 */
    const nextPaymentUsagePeriodText = I18n.t(
      'MypagePage.MypageContract.detailsPage.nextPaymentUsagePeriod',
      {
        period: props.myContractData.nextPaymentPeriod,
      },
    ).toString()

    /* 次の支払いに表示するテキスト */
    let nextPaymentText =
      props.myContractData.nextPaymentDate && props.myContractData.nextPaymentPrice
        ? `${props.myContractData.nextPaymentDate}<br>${props.myContractData.nextPaymentPrice}`
        : ''

    if (nextPaymentText && props.myContractData.nextPaymentPeriod) {
      // 利用期間が存在する場合は利用期間を表示する
      nextPaymentText += ` ${nextPaymentUsagePeriodText}`
    }

    return {
      nextPaymentText,
    }
  },
})
</script>

<style lang="scss" scoped>
.mypage-contract-details-section {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  letter-spacing: 0.02em;
  font-feature-settings: 'palt' on;
  color: $black;
  text-align: left;

  &__title {
    width: 100%;
    font-weight: 700;
  }

  .fieldset-confirm-parts {
    ::v-deep {
      dt {
        color: $black20;
      }

      dd {
        font-weight: 500;
        color: $black20;
      }
    }
  }
}
</style>
